import React from "react";
import { Cpu, Loader2 } from "lucide-react";
import { useQzTrayClient } from "../../../hooks/qztray/useQzTrayClient";

/**
 * 💻 ConnectionVersionBox
 *
 * Muestra la versión del cliente QZ Tray usando el hook centralizado.
 * No ejecuta funciones de conexión ni carga automática.
 */
const ConnectionVersionBox: React.FC = () => {
  const { version, isConnected, isLoading, fetchVersion } = useQzTrayClient();

  // 📦 Estado visual
  const displayVersion = isLoading ? "..." : version ?? "—";
  const connected = isConnected ? "Conectado" : "Desconectado";

  return (
    <div className="rounded-sm border border-stroke bg-white dark:border-strokedark dark:bg-boxdark shadow-md p-5 flex flex-col items-center justify-center transition-colors">
      {/* 🔹 Encabezado con ícono */}
      <div className="flex items-center gap-2 mb-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 dark:bg-primary/20">
          <Cpu className="h-5 w-5 text-primary" />
        </div>
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Versión QZ Tray
        </h4>
      </div>

      {/* 🔸 Valor principal */}
      <div className="flex flex-col items-center">
        {isLoading ? (
          <Loader2 className="h-5 w-5 text-primary animate-spin mb-1" />
        ) : (
          <span className="text-2xl font-bold text-primary tracking-wide">
            {displayVersion}
          </span>
        )}
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {connected === "Conectado"
            ? "Cliente activo localmente"
            : "Cliente no detectado"}
        </p>
      </div>

      {/* 🔘 Botón opcional para refrescar */}
      <button
        onClick={fetchVersion}
        disabled={isLoading}
        className="mt-3 text-xs text-primary underline hover:text-primary/80"
      >
        {isLoading ? "Actualizando..." : "Actualizar versión"}
      </button>
    </div>
  );
};

export default ConnectionVersionBox;
